var l={linkButton:"lds-link-button",disabled:"lds-link-button--disabled",sm:"lds-link-button--sm",uppercase:"lds-link-button--uppercase",capitalize:"lds-link-button--capitalize",arrow:"lds-link-button--arrow"};export{l as default};
